import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url, getAdjustedPrice } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";
import { generateBarcodeBase64 } from "../../../Services/Api";

const now = new Date();
const timestamp = now
    .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
    .replace(/[:.]/g, '-')   // Replace colon and dot with dash
    .replace('T', '_')       // Replace 'T' with underscore
    .split('Z')[0];          // Remove trailing 'Z'

export const generatePDF = (sectionsCount, bannerImg, withBarCode) => {

    const width = 1632;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [width, height],
    });

    const sectionWidth = width / 2;  // 1632 / 2 = 816 pt
    const sectionHeight = height / 2; // 1056 / 2 = 528 pt

    const bannerImgWidth = (width / 2) - 5;
    const bannerImgHeight = 94;

    const maxSectionsPerPage = 4; // 4 sections per page (2x2 grid per page)
    let currentSection = 0;

    // Loop through the sections and handle pages
    while (currentSection < sectionsCount.length) {
        // Add a new page if this isn't the first page
        if (currentSection > 0) {
            doc.addPage();
        }

        // Calculate number of sections on the current page
        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

        // ==========================================
        // FRONT SIDE GENERATION
        // ==========================================
        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const xPos = (i % 2) * (width / 2) + 2.5;
            const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

            if (sectionIndex < sectionsCount.length) {
                // Banner Image
                doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

                // Main Rectangle
                const sectionRectX = xPos + 2.5;
                const sectionRectY = yPos + bannerImgHeight + 4.8;
                const sectionRectWidth = sectionWidth / 2.9;
                const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);

                const sectionMainImageX = xPos + sectionRectWidth + 2.5;
                const sectionMainImageWidth = sectionWidth - (sectionRectWidth + 2.5);
                const sectionMainImageHeight = 290;

                const productImageUrl = sectionsCount[sectionIndex]?.image;
                const name = sectionsCount[sectionIndex]?.name;
                const sku = "Model#" + sectionsCount[sectionIndex]?.sku;
                const sale_price = sectionsCount[sectionIndex]?.variations[0].sale_price;
                const regular_price = sectionsCount[sectionIndex]?.variations[0].regular_price;

                if (productImageUrl) {
                    doc.addImage(productImageUrl, "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
                }

                doc.setFont("Montserrat-Bold", "bold");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(14);

                // Text position
                const textX = sectionMainImageX + (sectionMainImageWidth - 15);
                const textY = sectionRectY + 15;

                // Example text
                doc.text(name, textX, textY, { align: 'right' });
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(16);
                doc.setFont("helvetica", "normal");
                doc.text(sku, textX, textY + 20, { align: 'right' });

                doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

                // Horizontal divider inside main rectangle
                const lineY = sectionRectY + sectionRectHeight / 4;
                doc.setLineWidth(2);
                doc.line(
                    sectionRectX,
                    lineY,
                    sectionRectX + sectionRectWidth,
                    lineY
                );

                const subSection1Width = sectionWidth / 2.9;
                const wasPriceStartY = yPos;

                // Text for first line
                const text1 = sectionsCount[sectionIndex]?.variations[0].value;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(40, 142, 169);
                doc.setFontSize(11);
                const text1Width = doc.getTextWidth(text1);

                const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
                doc.text(text1, wasPriceStartX1, wasPriceStartY + 120);

                // Text for second line
                const text2 = "was $" + regular_price;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(16);
                const text2Width = doc.getTextWidth(text2);

                const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
                doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

                // Text for third line
                const text3 = "$" + sale_price;
                doc.setFont("Montserrat-Black", "normal");
                doc.setTextColor(253, 0, 0);
                doc.setFontSize(50);
                const text3Width = doc.getTextWidth(text3);

                const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
                doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);

                if (sectionsCount[sectionIndex]?.variations.length > 1) {
                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(11);
                    doc.text("Group Pricing", xPos + 10, lineY + 20);

                    for (let index = 1; index < sectionsCount[sectionIndex].variations.length; index++) {
                        const variation = sectionsCount[sectionIndex].variations[index];
                        const yOffset = lineY + 20 + index * 20;

                        doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(8);
                        doc.text(variation?.value || "N/A", xPos + 10, yOffset);

                        const valueWidth = doc.getTextWidth(variation?.value || "N/A");

                        doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                        doc.setTextColor(253, 0, 0);
                        doc.setFontSize(8);
                        doc.text(`$${variation?.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset);
                    }
                }

                // === Left Rectangle with Grid ===
                const gridRectX = xPos + (sectionWidth / 1.49);
                const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
                const gridRectW = sectionWidth / 3.1;
                const gridRectH = sectionHeight / 3.75;

                doc.setLineWidth(2);
                doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');

                const lineHeight = 15;
                const totalTextHeight = 4 * lineHeight;
                const verticalOffset = (gridRectH - totalTextHeight) / 2;

                const textX_g1 = gridRectX + (gridRectW / 2);
                const textY_g1 = gridRectY + verticalOffset;

                // Flags that decide whether this item qualifies for the financing display
                const lo = sectionsCount[sectionIndex]?.lo;
                const spiff = sectionsCount[sectionIndex]?.spiff;
                const spiffWithValue = sectionsCount[sectionIndex]?.spiffWithValue; 
                const spiffValue = sectionsCount[sectionIndex]?.spiff_value ? sectionsCount[sectionIndex]?.spiff_value : "N/A"; 


                const specTextY1 = gridRectY + gridRectH - 35; // "NO CREDIT 0 DOWN" — tweak offset to match current correct position
                const specTextY2 = gridRectY + gridRectH - 12; // "100 DAYS NO INTEREST"

                if (!lo && !spiff) {
                    // ---------- Existing financing block ----------
                    const text1_main = "$" + (getAdjustedPrice(sale_price)).toString();
                    const text1_suffix = "/week";

                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setFontSize(34);
                    const width_main = doc.getTextWidth(text1_main);

                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(14);
                    const width_suffix = doc.getTextWidth(text1_suffix);

                    const totalWidth = width_main + width_suffix + 2;

                    const combinedTextX = textX_g1 - (totalWidth / 2);

                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(253, 0, 0);
                    doc.setFontSize(34);
                    doc.text(text1_main, combinedTextX, textY_g1);

                    const suffixX = combinedTextX + width_main + 2;
                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(61, 124, 157);
                    doc.setFontSize(18);
                    doc.text(text1_suffix, suffixX, textY_g1);

                    const text2_g = "Subject to approval. some restrictions apply";
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(151, 68, 131);
                    doc.setFontSize(13);
                    const textY_g2 = gridRectY + verticalOffset + lineHeight + 12;
                    doc.text(text2_g, textX_g1, textY_g2, { align: 'center' });
                } else {
                    doc.setFont("helvetica", "bold");
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(14);

                    const showSpiff = spiff;
                    const showLo = lo;

                    if (showSpiff || showLo) {
                        const rowY = gridRectY + (verticalOffset - 15);

                        const labelStartX = gridRectX + 10;
                        const lineEndX = gridRectX + gridRectW - 10;
                        const lineGap = 8;
                        const pairGap = 20;

                        const spiffLabel = "SPIFF :";
                        const loLabel = "LO :";

                        // NEW: value to print next to SPIFF when both spiff + spiffWithValue are true
                        const spiffValueText = (spiff && spiffWithValue) ? `${spiffValue}` : null;

                        doc.setLineWidth(1);
                        doc.setDrawColor(0, 0, 0);

                        if (showSpiff && showLo) {
                            const spiffLabelWidth = doc.getTextWidth(spiffLabel);
                            const loLabelWidth = doc.getTextWidth(loLabel);

                            const totalWidth = lineEndX - labelStartX;
                            const spiffBlockW = totalWidth * 0.55;
                            const spiffLineEndX = labelStartX + spiffBlockW - pairGap / 2;

                            const loLabelStartX = labelStartX + spiffBlockW + pairGap / 2;
                            const loLineEndX = lineEndX;

                            // SPIFF label
                            doc.setFont("helvetica", "bold");
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(14);
                            doc.text(spiffLabel, labelStartX, rowY, { align: 'left' });
                            const spiffLineStartX = labelStartX + spiffLabelWidth + lineGap;

                            // NEW: write "1.22" right after "SPIFF :"
                            if (spiffValueText) {
                                doc.setFont("helvetica", "bold");
                                doc.setTextColor(253, 0, 0);
                                doc.setFontSize(14);
                                doc.text(spiffValueText, spiffLineStartX, rowY, { align: 'left' });
                            }

                            // LO label
                            doc.setFont("helvetica", "bold");
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(14);
                            doc.text(loLabel, loLabelStartX, rowY, { align: 'left' });
                            const loLineStartX = loLabelStartX + loLabelWidth + lineGap;

                        } else if (showSpiff) {
                            const spiffLabelWidth = doc.getTextWidth(spiffLabel);
                            doc.setFont("helvetica", "bold");
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(14);
                            doc.text(spiffLabel, labelStartX, rowY, { align: 'left' });
                            const spiffLineStartX = labelStartX + spiffLabelWidth + lineGap;

                            // NEW: write "1.22" right after "SPIFF :"
                            if (spiffValueText) {
                                doc.setFont("helvetica", "bold");
                                doc.setTextColor(253, 0, 0);
                                doc.setFontSize(14);
                                doc.text(spiffValueText, spiffLineStartX, rowY, { align: 'left' });
                            }

                        } else if (showLo) {
                            const loLabelWidth = doc.getTextWidth(loLabel);
                            doc.setFont("helvetica", "bold");
                            doc.setTextColor(0, 0, 0);
                            doc.setFontSize(14);
                            doc.text(loLabel, labelStartX, rowY, { align: 'left' });
                            const loLineStartX = labelStartX + loLabelWidth + lineGap;
                        }
                    }

                    const separatorY = gridRectY + gridRectH - 65;
                    doc.setLineWidth(0.75);
                    doc.setDrawColor(0, 0, 0);
                    doc.line(gridRectX, separatorY, gridRectX + gridRectW, separatorY);
                }

                // ---------- Always shown, spaced below whichever block rendered above ----------
                const baseY = lo && spiff
                    ? gridRectY + verticalOffset + lineHeight + 12   // right after "Subject to approval..." line
                    : gridRectY + verticalOffset + 18 + 22;          // right after LO line

                const text3_g = "NO CREDIT 0 DOWN";
                doc.setFont("helvetica", "bold");
                doc.setTextColor(136, 194, 87);
                doc.setFontSize(24);
                const textY_g3 = baseY + 26;
                doc.text(text3_g, textX_g1, specTextY1, { align: 'center' });

                const text4_g = "100 DAYS NO INTEREST";
                doc.setFont("helvetica", "bold");
                doc.setTextColor(56, 112, 151);
                doc.setFontSize(18);
                const textY_g4 = textY_g3 + 22;
                doc.text(text4_g, textX_g1, specTextY2, { align: 'center' });

                // Right rectangle
                const rightRectX = xPos + (sectionWidth / 2.83);
                const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
                const rightRectW = sectionWidth / 3.2;
                const rightRectH = sectionHeight / 3.75;

                doc.setLineWidth(2);
                doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');

                const col1 = rightRectW * 0.3;
                const col2 = rightRectW * 0.2;
                const col3 = rightRectW * 0.3;
                const col4 = rightRectW * 0.2;

                const rowHeight = rightRectH / 4;

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);

                for (let r = 1; r < 5; r++) {
                    const y = rightRectY + r * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);
                }

                const colX1 = rightRectX + col1;
                const colX2 = colX1 + col2;
                const colX3 = colX2 + col3;

                doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH);
                doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH);
                doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH);

                const values = sectionsCount[sectionIndex]?.individuals || [];
                const itemsPerRow = 2;
                const totalRows = Math.ceil(values.length / itemsPerRow);

                for (let r = 0; r < totalRows; r++) {
                    const y = rightRectY + (r + 1) * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);

                    const leftIndex = r * itemsPerRow;
                    const rightIndex = leftIndex + 1;

                    if (values[leftIndex]) {
                        const left = values[leftIndex];
                        const leftLabel = left.inputValue || "";
                        const leftSlug = left.p_price ? "$" + left.p_price : "";

                        const leftLabelX = rightRectX + col1 / 2 - 30;
                        const leftSlugX = rightRectX + col1 + col2 / 2 - 15;

                        const textY = y - rowHeight / 2 + 2;
                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(12);

                        doc.text(leftLabel, leftLabelX, textY, { align: 'left' });
                        doc.setTextColor(252, 0, 0);
                        doc.text(leftSlug, leftSlugX, textY, { align: 'left' });
                    }

                    if (values[rightIndex]) {
                        const right = values[rightIndex];
                        const rightLabel = right.inputValue || "";
                        const rightSlug = right.p_price ? "$" + right.p_price : "";

                        const rightLabelX = rightRectX + col1 + col2 + col3 / 2 - 30;
                        const rightSlugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;

                        const textY = y - rowHeight / 2 + 2;
                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(12);

                        doc.text(rightLabel, rightLabelX, textY, { align: 'left' });
                        doc.setTextColor(252, 0, 0);
                        doc.text(rightSlug, rightSlugX, textY, { align: 'left' });
                    }
                }
            }
        }
        // Guidelines
        doc.setLineDashPattern([10, 5], 0);
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(0, height / 2, width, height / 2);
        doc.line(width / 2, 0, width / 2, height);

        // ==========================================
        // BACK SIDE GENERATION (COLUMN-WISE GRID)
        // ==========================================
        if (withBarCode === true) {
            doc.addPage();

            doc.setLineDashPattern([10, 5], 0);
            doc.setDrawColor(0);
            doc.setLineWidth(1);

            doc.line(0, height / 2, width, height / 2);
            doc.line(width / 2, 0, width / 2, height);

            for (let i = 0; i < sectionsOnThisPage; i++) {
                const bannerImgHeight = 0;
                const sectionIndex = currentSection + i;
                const section = sectionsCount[sectionIndex];

                if (!section) continue;

                const xPos = (i % 2) * (width / 2) + 2.5;
                const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

                const rectX = xPos + 2.5;
                const rectY = yPos + bannerImgHeight + 5;
                const rectW = sectionWidth - 5;
                const rectH = sectionHeight - bannerImgHeight - 10;

                // ==========================================
                // HEADER STYLING: Main Product Name + Perfectly Aligned "Default" Tag
                // ==========================================
                const mainProductName = (section?.name || "") + " " + "(Bar Codes)";
                const badgeText = "Default";

                // Set font for name layout calculation
                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(14);

                const nameWidth = doc.getTextWidth(mainProductName);

                // Calculate Badge parameters
                const badgePaddingX = 8;
                const badgePaddingY = 3;
                doc.setFontSize(9);
                const badgeTextWidth = doc.getTextWidth(badgeText);
                const badgeWidth = badgeTextWidth + (badgePaddingX * 2);
                const badgeHeight = 12 + (badgePaddingY * 2);

                const gapBetweenNameAndBadge = 8;
                const totalHeaderWidth = nameWidth + gapBetweenNameAndBadge + badgeWidth;

                // Layout Starting coordinates (Centering the entire header block seamlessly)
                const startX = rectX + ((rectW - totalHeaderWidth) / 2);
                const headerTextY = rectY + 20;


                // 1. Draw Main Product Name
                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(14);
                doc.setTextColor(0, 0, 0);
                doc.text(mainProductName, startX, headerTextY, { align: "left" });

                // 2. Draw "Default" Badge Background
                const badgeX = startX + nameWidth + gapBetweenNameAndBadge;
                const badgeY = headerTextY - 10.5;

                // 4. Solid Underline across the absolute section width
                doc.setLineWidth(1);
                doc.setDrawColor(0, 0, 0);
                doc.setLineDashPattern([], 0);

                const underlineY = headerTextY + 12;
                doc.line(rectX - 2.5, underlineY, rectX + rectW, underlineY);
                // ==========================================

                const variations = section?.variations || [];
                const groupItems = variations.slice(1);
                const individuals = section?.individuals || [];

                // Main items dataset
                const mainBlock = [
                    {
                        value: variations?.[0]?.value,
                        sku: section?.sku,
                        price: null,
                    },
                    ...groupItems.map(v => ({
                        value: v?.value,
                        sku: v?.sku,
                        price: v?.sale_price,
                    }))
                ];

                // Filter individuals: Only include items that contain a valid name AND a valid SKU
                const indBlock = individuals
                    .filter(v => v?.inputValue && v.inputValue.trim() !== "" && v?.sku && v.sku.trim() !== "")
                    .map(v => ({
                        value: v?.inputValue,
                        sku: v?.sku,
                        price: v?.p_price,
                    }));

                // Unified sequence stream with structural heading insertion logic
                const allItems = [...mainBlock];
                if (indBlock.length > 0) {
                    // allItems.push({ isHeading: false, value: "Individual Items" });
                    allItems.push(...indBlock);
                }

                const totalItems = allItems.length;

                // Skip processing entirely if there are no items to render
                if (totalItems === 0) continue;

                const columnCount = totalItems > 14 ? 3 : 2;

                // Strict alignment threshold rule: 7 entries vertical offset loop breaker
                const itemsPerColumn = 7;

                const colWidth = (rectW - 10) / columnCount;
                const columnsX = Array.from({ length: columnCount }, (_, i) =>
                    rectX + 5 + i * colWidth
                );

                // Separate axis Y trackers per lane starting safely below the header underline block
                const columnY = Array(columnCount).fill(underlineY + 20);

                // Item generation drawing engine
                const renderItem = (item, colIndex, globalIndex) => {
                    const x = columnsX[colIndex];
                    let y = columnY[colIndex];

                    if (item.isHeading) {
                        y += 5; // Extra padding from previous item
                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setFontSize(10);
                        doc.setTextColor(71, 74, 119); // Matches system primary dark blue
                        doc.text(item.value, x, y);

                        // Simple text boundary baseline tracker line
                        const headingWidth = doc.getTextWidth(item.value);
                        doc.setLineWidth(1);
                        doc.setDrawColor(71, 74, 119);
                        doc.line(x, y + 3, x + headingWidth, y + 3);

                        columnY[colIndex] = y + 18; // Track next sequence offset
                        return;
                    }

                    // --- Variation Label Line ---
                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.value || "", x, y);

                    const labelWidth = doc.getTextWidth(item.value || "");

                    // Add "DEFAULT" Badge right after the main variation value (globalIndex === 0)
                    if (globalIndex === 0 && item.value) {
                        const badgeText = "DEFAULT";

                        doc.setFontSize(5);
                        const bTextWidth = doc.getTextWidth(badgeText);
                        const bPaddingX = 2;
                        const bPaddingY = 1;
                        const bWidth = bTextWidth + (bPaddingX * 2);
                        const bHeight = 8 + (bPaddingY * 2);

                        const bX = x + labelWidth + 4;
                        const bY = y - 8.5; // Precise baseline offset matching alignment height

                        // Render filled light gray pill background with a 4px border radius
                        doc.setFillColor(40, 142, 169);
                        doc.roundedRect(bX, bY, bWidth, bHeight, 2, 2, 'F');

                        // Render dark text over pill
                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setTextColor(255, 255, 255);
                        doc.text(badgeText, bX + bPaddingX, bY + 6.4);

                        // Reset font size back to item value context sizes
                        doc.setFontSize(8);
                    }

                    doc.setTextColor(255, 0, 0);
                    doc.text(item.price ? `$${item.price}` : "", x + labelWidth + 10, y);

                    y += 10;

                    // --- SKU Line ---
                    doc.setFont("Montserrat-Bold", "bold");
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.sku || "", x, y);

                    if (item.sku) {
                        const barcodeImg = generateBarcodeBase64(item.sku);
                        doc.addImage(
                            barcodeImg,
                            "PNG",
                            x,
                            y,
                            colWidth - 10,
                            40
                        );
                        y += 35;
                    }

                    columnY[colIndex] = y + 20;
                };

                // Process entire pipeline into columns down the lines vertically first
                allItems.forEach((item, index) => {
                    let colIndex = Math.floor(index / itemsPerColumn);

                    // RESTRICTION RULE: If this item is a heading AND it's scheduled to land at the 
                    // very bottom (last index) of a column, force it to the top of the next column instead.
                    if (item.isHeading && (index % itemsPerColumn === itemsPerColumn - 1)) {
                        colIndex += 1;
                    }

                    const targetCol = colIndex >= columnCount ? columnCount - 1 : colIndex;
                    renderItem(item, targetCol, index);
                });
            }
        }

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags_${timestamp}.pdf`);
};